import { useEffect } from 'react';
import { connect } from 'react-redux';
import { settingsActions } from '../../reducers/settings.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import FeatureFlagsCard from './feature-flags/FeatureFlagsCard.react';
import FeatureFlagsAdd from './feature-flags/FeatureFlagsAdd.modal';
import Card from '../common/card/Card.react';
import CardBody from '../common/card/CardBody.react';
import Button from '../common/Button.react';
var FeatureFlags = function FeatureFlags(_ref) {
  var applicationConstants = _ref.applicationConstants,
    getFeatureFlagsAction = _ref.getFeatureFlagsAction,
    addModalAction = _ref.addModalAction,
    featureFlagConstants = _ref.featureFlagConstants;
  useEffect(function () {
    getFeatureFlagsAction();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      width: 420
    }
  }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Add New Feature Flag",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(FeatureFlagsAdd, {
          featureFlagConstants: featureFlagConstants
        })
      });
    },
    style: {
      width: '100%'
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, applicationConstants.filter(function (x) {
    return x.key === 'cms';
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(FeatureFlagsCard, {
      application: x,
      key: x.id
    });
  }))));
};
var mstp = function mstp(s) {
  var _s$settings$constants, _s$settings$constants2;
  return {
    applicationConstants: ((_s$settings$constants = s.settings.constants) === null || _s$settings$constants === void 0 ? void 0 : _s$settings$constants.applications) || [],
    featureFlagConstants: ((_s$settings$constants2 = s.settings.constants) === null || _s$settings$constants2 === void 0 ? void 0 : _s$settings$constants2.featureFlags) || []
  };
};
var mdtp = {
  getFeatureFlagsAction: settingsActions.getFeatureFlags,
  addModalAction: modalActions.add
};
export default connect(mstp, mdtp)(FeatureFlags);